import React from 'react'

const HeroSlidesData =  [
{
    id: 1,
    header: 'EXPERIENCE LUXURY, LIVE THE LIFESTYLE',
    subheader: 'Individuals who use our services can benefit greatly from our fleet of luxury cars, proximity to their order locations, drivers’ professionalism',
    image: 'images/hero/hero1.jpeg',
},
{
    id: 2,
    header: 'FOR THOSE WHO DEMAND THE BEST',
    subheader: "Drive the world's most prestigious cars with Entourage, where luxury meets exclusivity.",
    image: 'images/hero/hero2.jpeg',
},
{
    id: 3,
    header: 'REDEFINE YOUR PRESENCE',
    subheader: "Whether for business or pleasure, Entourage ensures you make a statement, every mile of the way.",
    image: 'images/hero/hero3.jpeg',
},
]
export default HeroSlidesData